import React, { MouseEventHandler } from 'react';

import { getClassNames } from '../../../../../utils/util';

import './tribe-approval-button.scss';

type Props = {
  text: string;
  onClick: MouseEventHandler<HTMLDivElement>;
  approved?: boolean;
  declined?: boolean;
};

const TribeApprovalButton = ({ text, onClick, approved = false, declined = false }: Props) => {
  return (
    <div
      className={getClassNames('tribe-approval-button', { approved, declined })}
      onClick={onClick}
      data-testid="tribe-approval-button"
    >
      <p className={getClassNames('tribe-approval-button__text', { approved, declined })}>{text}</p>
      <p className="tribe-approval-button__undo-text">UNDO</p>
    </div>
  );
};

export default TribeApprovalButton;
